import { z } from 'zod';
// Root album creation: caller supplies the AES-wrapped K_album. Children
// inherit the root's key so they never carry one themselves.
export const CreateRootAlbumRequest = z.object({
    encryptedName: z.string().min(1),
    wrappedAlbumKey: z.string().min(1),
});
export const CreateChildAlbumRequest = z.object({
    parentId: z.string().min(1),
    encryptedName: z.string().min(1),
});
export const CreateAlbumRequest = z.union([CreateRootAlbumRequest, CreateChildAlbumRequest]);
export const Album = z.object({
    id: z.string(),
    ownerId: z.string(),
    parentId: z.string().nullable(),
    rootAlbumId: z.string(),
    encryptedName: z.string(),
    wrappedAlbumKey: z.string().optional(),
    // Generation of K_album currently authoritative for this root. Photos under
    // this root are encrypted with the K_album of the gen recorded on each
    // Photo row. Old albums without this field are treated as gen 1.
    keyGen: z.number().int().positive().optional(),
    // Set only while a key rotation is in progress: the next-generation
    // wrappedAlbumKey for the owner. Cleared by rotate-commit.
    wrappedAlbumKeyNext: z.string().optional(),
    coverPhotoId: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string().optional(),
});
export const AlbumListResponse = z.object({
    albums: z.array(Album),
});
export const AlbumTreeResponse = z.object({
    rootId: z.string(),
    nodes: z.array(Album),
});
export const UpdateAlbumRequest = z
    .object({
    encryptedName: z.string().min(1).optional(),
    parentId: z.string().min(1).optional(),
})
    .refine((v) => v.encryptedName !== undefined || v.parentId !== undefined, {
    message: 'at least one of encryptedName or parentId is required',
});
//# sourceMappingURL=album.js.map